import { billOfMaterialsTemplateBindingIdFormat } from "@redotech/redo-fulfillment-id";
import { BomTemplateYield } from "@redotech/redo-inventory-common/bill-of-materials/bom-template-spec";
import * as z from "zod";

export const setBomTemplateYield = {
  name: "setBomTemplateYield" as const,
  input: z.object({
    bindingId: billOfMaterialsTemplateBindingIdFormat.schema,
    yield: BomTemplateYield,
  }),
  output: z.object({}),
};
